import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7a4d94dc"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "inner-page"
}
const _hoisted_2 = {
  key: 1,
  class: "section-profile"
}
const _hoisted_3 = { class: "tender" }
const _hoisted_4 = { class: "h2-title mobile-only" }
const _hoisted_5 = { class: "tender-title title-bordered is-short no-h-styling" }
const _hoisted_6 = {
  class: "tender-info is-short",
  "data-blocks": "4"
}
const _hoisted_7 = { class: "tender-info-item" }
const _hoisted_8 = { class: "tender-field-title" }
const _hoisted_9 = { class: "tender-field-info" }
const _hoisted_10 = { class: "tender-info-item" }
const _hoisted_11 = { class: "tender-field-title" }
const _hoisted_12 = { class: "tender-field-info" }
const _hoisted_13 = { class: "tender-info-item" }
const _hoisted_14 = { class: "tender-field-title" }
const _hoisted_15 = { class: "tender-field-info" }
const _hoisted_16 = { class: "tender-info-item" }
const _hoisted_17 = { class: "tender-field-title" }
const _hoisted_18 = { class: "tender-field-info" }
const _hoisted_19 = { class: "tender-info-item" }
const _hoisted_20 = { class: "tender-field-title" }
const _hoisted_21 = { class: "tender-field-info" }
const _hoisted_22 = { class: "tender-info-item" }
const _hoisted_23 = { class: "tender-field-title" }
const _hoisted_24 = { class: "tender-field-info" }
const _hoisted_25 = { class: "tender-info-item" }
const _hoisted_26 = { class: "tender-field-title" }
const _hoisted_27 = { class: "tender-field-info" }
const _hoisted_28 = { class: "tender-info-item" }
const _hoisted_29 = { class: "tender-field-title" }
const _hoisted_30 = { class: "tender-field-info" }
const _hoisted_31 = ["href"]
const _hoisted_32 = { key: 1 }
const _hoisted_33 = {
  class: "tender-info is-short",
  "data-blocks": "1"
}
const _hoisted_34 = { class: "tender-info-item" }
const _hoisted_35 = { class: "tender-field-title" }
const _hoisted_36 = { class: "tender-field-info" }
const _hoisted_37 = {
  class: "tender-info is-short",
  "data-blocks": "4"
}
const _hoisted_38 = { class: "tender-info-item" }
const _hoisted_39 = { class: "tender-field-title" }
const _hoisted_40 = { class: "tender-field-info" }
const _hoisted_41 = { class: "tender-info-item" }
const _hoisted_42 = { class: "tender-field-title" }
const _hoisted_43 = { class: "tender-field-info" }
const _hoisted_44 = {
  key: 0,
  class: "tender-info is-short",
  "data-blocks": "1"
}
const _hoisted_45 = { class: "tender-info-item" }
const _hoisted_46 = { class: "tender-field-title is-bigger" }
const _hoisted_47 = { class: "tender-field-info" }
const _hoisted_48 = {
  key: 1,
  class: "tender-info is-short",
  "data-blocks": "1"
}
const _hoisted_49 = { class: "tender-info-item" }
const _hoisted_50 = { class: "tender-field-title is-bigger" }
const _hoisted_51 = { class: "tender-field-files" }
const _hoisted_52 = ["href", "target"]
const _hoisted_53 = ["innerHTML"]
const _hoisted_54 = { class: "objects mobile-only" }
const _hoisted_55 = { class: "tender-field-title tender-auction" }
const _hoisted_56 = { class: "tender-title title-bordered is-short company-url" }
const _hoisted_57 = { key: 1 }
const _hoisted_58 = {
  class: "tender-info is-short",
  "data-blocks": "4"
}
const _hoisted_59 = { class: "tender-info-item" }
const _hoisted_60 = { class: "tender-field-title" }
const _hoisted_61 = { class: "tender-field-info" }
const _hoisted_62 = { class: "tender-info-item" }
const _hoisted_63 = { class: "tender-field-title" }
const _hoisted_64 = { class: "tender-field-info" }
const _hoisted_65 = { class: "tender-info-item" }
const _hoisted_66 = { class: "tender-field-title" }
const _hoisted_67 = { class: "tender-field-info" }
const _hoisted_68 = { class: "tender-info-item" }
const _hoisted_69 = { class: "tender-field-title" }
const _hoisted_70 = { class: "tender-field-info" }
const _hoisted_71 = {
  key: 0,
  class: "objects"
}
const _hoisted_72 = { class: "tender-title title-bordered is-short" }
const _hoisted_73 = { class: "objects-list is-short" }
const _hoisted_74 = {
  key: 0,
  class: "object-item"
}
const _hoisted_75 = {
  key: 1,
  class: "mobile-footer-btns"
}
const _hoisted_76 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderSecondary = _resolveComponent("HeaderSecondary")!
  const _component_SidebarTender = _resolveComponent("SidebarTender")!
  const _component_LoadingSpinner = _resolveComponent("LoadingSpinner")!
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_LotItem = _resolveComponent("LotItem")!
  const _component_FooterMobile = _resolveComponent("FooterMobile")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_HeaderSecondary),
    (_ctx.getTender !== null)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_SidebarTender),
          _createElementVNode("main", null, [
            (_ctx.isLoading)
              ? (_openBlock(), _createBlock(_component_LoadingSpinner, { key: 0 }))
              : _createCommentVNode("", true),
            (!_ctx.isLoading)
              ? (_openBlock(), _createElementBlock("section", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.$t("tender_details.purchase")), 1),
                    _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.formatName(_ctx.getTender)), 1),
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t("search.status")), 1),
                        _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.getTender.status ? _ctx.getTender.status 
                  : _ctx.isFinished ? _ctx.$t("search.status_closed") 
                  : _ctx.$t("search.status_open")), 1)
                      ]),
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t("tender_details.type")), 1),
                        _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.getTender.type), 1)
                      ]),
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.$t("tender_details.country")), 1),
                        _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.getTender.country), 1)
                      ]),
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.$t("tender_details.region")), 1),
                        _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.getTender.region !== null ? _ctx.getTender.region : "–"), 1)
                      ]),
                      _createElementVNode("div", _hoisted_19, [
                        _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.$t("tender_details.contract_amount")), 1),
                        _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.getTender.price !== null
                    ? `${_ctx.getTender.price.toLocaleString("en-US", {
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 2,
                      })} ${_ctx.getTender.currency}`
                    : "–"), 1)
                      ]),
                      _createElementVNode("div", _hoisted_22, [
                        _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.$t("tender_details.deposit_amount")), 1),
                        _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.getTender.deposit !== null
                    ? `${_ctx.getTender.deposit.toLocaleString("en-US", {
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 2,
                      })} ${_ctx.getTender.currency}`
                    : "–"), 1)
                      ]),
                      _createElementVNode("div", _hoisted_25, [
                        _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.$t("tender_details.winner_amount")), 1),
                        _createElementVNode("div", _hoisted_27, _toDisplayString(typeof _ctx.getTender.winner_price === "number"
                    ? `${_ctx.getTender.winner_price.toLocaleString("en-US", {
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 2,
                      })} ${_ctx.getTender.currency}`
                    : "–"), 1)
                      ]),
                      _createElementVNode("div", _hoisted_28, [
                        _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.$t("tender_details.winner")), 1),
                        _createElementVNode("div", _hoisted_30, [
                          (_ctx.includeWinnerLink)
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 0,
                                href: `/company/${_ctx.getTender.winner_inn}?page=1`,
                                target: "_blank",
                                class: "company-url",
                                onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.handleClickCompany($event, _ctx.getTender.winner_inn)), ["stop","prevent"]))
                              }, _toDisplayString(_ctx.getTender.winner), 9, _hoisted_31))
                            : (_openBlock(), _createElementBlock("span", _hoisted_32, _toDisplayString(typeof _ctx.getTender.winner === "string" ? _ctx.getTender.winner : "–"), 1))
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_33, [
                      _createElementVNode("div", _hoisted_34, [
                        _createElementVNode("div", _hoisted_35, _toDisplayString(_ctx.$t("tender_details.address")), 1),
                        _createElementVNode("div", _hoisted_36, _toDisplayString(_ctx.getTender.address !== null ? _ctx.getTender.address : "–"), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_37, [
                      _createElementVNode("div", _hoisted_38, [
                        _createElementVNode("div", _hoisted_39, _toDisplayString(_ctx.$t("search.start_date")), 1),
                        _createElementVNode("div", _hoisted_40, _toDisplayString(_ctx.formatDate(_ctx.getTender.start_date)), 1)
                      ]),
                      _createElementVNode("div", _hoisted_41, [
                        _createElementVNode("div", _hoisted_42, _toDisplayString(_ctx.$t("search.end_date")), 1),
                        _createElementVNode("div", _hoisted_43, _toDisplayString(_ctx.formatDate(_ctx.getTender.end_date)), 1)
                      ])
                    ]),
                    (_ctx.getTender.description)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                          _createElementVNode("div", _hoisted_45, [
                            _createElementVNode("div", _hoisted_46, _toDisplayString(_ctx.$t("tender_details.description")), 1),
                            _createElementVNode("div", _hoisted_47, _toDisplayString(_ctx.getTender.description), 1)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.getTender.files?.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                          _createElementVNode("div", _hoisted_49, [
                            _createElementVNode("div", _hoisted_50, _toDisplayString(_ctx.$t("tender_details.files")), 1),
                            _createElementVNode("div", _hoisted_51, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getTender.files, (file) => {
                                return (_openBlock(), _createElementBlock("a", {
                                  href: _ctx.prepareFileUrl(file),
                                  key: JSON.parse(file).file_url,
                                  target: _ctx.getTender.source === 'xarid_uzex' ? '_blank' : undefined,
                                  class: "is-docx",
                                  rel: "nofollow"
                                }, [
                                  _createElementVNode("span", {
                                    innerHTML: _ctx.formatFilename(JSON.parse(file).file_name)
                                  }, null, 8, _hoisted_53)
                                ], 8, _hoisted_52))
                              }), 128))
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_54, [
                    _createElementVNode("div", _hoisted_55, _toDisplayString(_ctx.getTender.company_inn || "–"), 1),
                    _createElementVNode("div", _hoisted_56, [
                      (_ctx.getTender.company_inn)
                        ? (_openBlock(), _createBlock(_component_RouterLink, {
                            key: 0,
                            to: { path: `/company/${_ctx.getTender.company_inn}`, query: { page: '1' }},
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleClickCompany($event, _ctx.getTender.company_inn))),
                            class: "company-url"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.getTender.company), 1)
                            ]),
                            _: 1
                          }, 8, ["to"]))
                        : (_openBlock(), _createElementBlock("span", _hoisted_57, _toDisplayString(_ctx.getTender.company), 1))
                    ]),
                    _createElementVNode("div", _hoisted_58, [
                      _createElementVNode("div", _hoisted_59, [
                        _createElementVNode("div", _hoisted_60, _toDisplayString(_ctx.$t("tender_details.contact_person")), 1),
                        _createElementVNode("div", _hoisted_61, _toDisplayString(_ctx.getTender.contact_person || "–"), 1)
                      ]),
                      _createElementVNode("div", _hoisted_62, [
                        _createElementVNode("div", _hoisted_63, _toDisplayString(_ctx.$t("tender_details.phone")), 1),
                        _createElementVNode("div", _hoisted_64, _toDisplayString(_ctx.getTender.phone || "–"), 1)
                      ]),
                      _createElementVNode("div", _hoisted_65, [
                        _createElementVNode("div", _hoisted_66, _toDisplayString(_ctx.$t("tender_details.email")), 1),
                        _createElementVNode("div", _hoisted_67, _toDisplayString(_ctx.getTender.email || "–"), 1)
                      ]),
                      _createElementVNode("div", _hoisted_68, [
                        _createElementVNode("div", _hoisted_69, _toDisplayString(_ctx.$t("tender_details.company_inn")), 1),
                        _createElementVNode("div", _hoisted_70, _toDisplayString(_ctx.getTender.company_inn || "–"), 1)
                      ])
                    ])
                  ]),
                  (_ctx.getTender.lots.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_71, [
                        _createElementVNode("div", _hoisted_72, _toDisplayString(_ctx.$t("tender_details.lots")), 1),
                        _createElementVNode("div", _hoisted_73, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getTender.lots, (lot) => {
                            return (_openBlock(), _createBlock(_component_LotItem, {
                              lot: lot,
                              key: lot.id
                            }, null, 8, ["lot"]))
                          }), 128)),
                          (_ctx.getTender.lots && _ctx.getTender.lots.length % 50 === 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_74, [
                                _createElementVNode("button", {
                                  class: "btn btn-white btn-show-more",
                                  onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.getTenderDetails({tenderId: _ctx.getTender.id, numLots: _ctx.getTender.lots.length + 50})), ["prevent"]))
                                }, _toDisplayString(_ctx.$t("tender_page.show_more_btn")), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.getTender !== null)
      ? (_openBlock(), _createElementBlock("div", _hoisted_75, [
          (_ctx.isAuthenticated && !_ctx.isFavourite)
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleSavePurchase && _ctx.handleSavePurchase(...args))),
                class: "btn btn-blue btn--w-icon save-search-btn"
              }, _toDisplayString(_ctx.$t("tender_page.add_favourite_btn")), 1))
            : (_ctx.isAuthenticated && _ctx.isFavourite)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 1,
                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.handleDeletePurchase && _ctx.handleDeletePurchase(...args))),
                  class: "btn btn-white btn--w-icon save-search-btn"
                }, _toDisplayString(_ctx.$t("tender_page.is_favourite")), 1))
              : (_openBlock(), _createElementBlock("a", {
                  key: 2,
                  onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.toggleAuthModal && _ctx.toggleAuthModal(...args))),
                  class: "btn btn-blue btn--w-icon save-search-btn"
                }, _toDisplayString(_ctx.$t("tender_page.add_favourite_btn")), 1)),
          _createElementVNode("a", {
            href: _ctx.getTender.url,
            target: "_blank",
            class: "btn btn-white"
          }, _toDisplayString(_ctx.$t("tender_page.source")), 9, _hoisted_76)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_FooterMobile)
  ], 64))
}